export const FETCH_START = "FETCH_START";
export const FETCH_END = "FETCH_END";